module.exports = __webpack_public_path__ + "static/img/gptModel61.2e93be70.png";